import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sba-initialize-exercise-dialog',
  templateUrl: './initialize-exercise-dialog.component.html',
  styleUrls: ['./initialize-exercise-dialog.component.scss']
})

export class InitializeExerciseDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<InitializeExerciseDialogComponent>,
  ) {
    this.dialogRef.disableClose = true;
   }
}
